import { Reveal } from "./Reveal";

const steps = [
  { n: "01", title: "Discovery Call", text: "Share your product vision, target customer, timeline, and goals with our team." },
  { n: "02", title: "Requirement Understanding", text: "We understand your brand, budget, and category requirements in detail." },
  { n: "03", title: "Formula Development", text: "Our chemists develop your formula tailored to your requirements." },
  { n: "04", title: "Sample Evaluation", text: "Review and evaluate samples against your expectations." },
  { n: "05", title: "Formula Finalisation", text: "Refine and lock the final formulation ready for production." },
  { n: "06", title: "Manufacturing (If applicable)", text: "Move into commercial production through our licensed manufacturing partners." },
  { n: "07", title: "Launch", text: "Your finished product is ready to ship and sell." },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-24 lg:py-32 bg-ivory scroll-mt-20">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <Reveal className="text-center">
          <p className="text-[12px] uppercase tracking-[0.22em] font-semibold text-navy">Our Process</p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl text-navy">
            From First Call to Finished Product
          </h2>
        </Reveal>

        <div className="mt-16 relative">
          <span className="absolute left-[19px] top-2 bottom-2 w-px bg-navy/20" aria-hidden="true" />
          <div className="flex flex-col gap-11">
            {steps.map(({ n, title, text }, i) => (
              <Reveal key={n} delay={i * 0.08}>
                <div className="group relative flex items-start gap-6" data-testid={`process-step-${n}`}>
                  <span className="relative z-10 grid place-items-center w-10 h-10 shrink-0 rounded-full bg-navy text-ivory font-display italic text-sm ring-4 ring-ivory transition-all duration-300 cursor-default group-hover:scale-125 group-hover:shadow-[0_0_0_6px_rgba(62,74,46,0.15)]">
                    {n}
                  </span>
                  <div className="pt-1">
                    <h3 className="font-display text-xl text-navy leading-snug transition-colors duration-300 group-hover:text-charcoal">
                      {title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-charcoal/75">{text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
